import {
  Sun, Moon, Star, Heart, Leaf, Flower, Dog, Cat, Fish, Bird, Drop, Rainbow, Rabbit, Butterfly, Horse, Cow,
  HandPointing, Camera, Eye, SprayBottle, Lightbulb, Ruler, Hand, ChatCircleDots, Bug, WarningCircle, DeviceMobile, CheckCircle, Sparkle,
} from "@phosphor-icons/react";
import { api, shrink } from "./api";

const data = (p) => p.then((r) => r.data);

export const kidApi = {
  upload: async (raw) => { const fd = new FormData(); fd.append("file", await shrink(raw)); return data(api.post("/kid/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })); },
  login: (username, picture_password) => data(api.post("/kid-auth/login", { username, picture_password })),
  logout: () => data(api.post("/kid-auth/logout")),
  me: () => data(api.get("/kid/me")),
  care: (plantId, kind, photo_path) => data(api.post(`/kid/plants/${plantId}/care`, { kind, ...(photo_path ? { photo_path } : {}) })),
  photo: (plantId, photo_path) => data(api.post(`/kid/plants/${plantId}/photo`, { photo_path })),
  help: (plantId, body) => data(api.post(`/kid/plants/${plantId}/help`, body)),
  lessonDone: (key) => data(api.post(`/kid/lessons/${key}/done`)),
  list: () => data(api.get("/kids")),
  summary: (id) => data(api.get(`/kids/${id}/summary`)),
  create: (body) => data(api.post("/kids", body)),
  update: (id, body) => data(api.patch(`/kids/${id}`, body)),
  remove: (id) => data(api.delete(`/kids/${id}`)),
  plantKids: (plantId) => data(api.get(`/plants/${plantId}/kids`)),
  assign: (plantId, kidId, assigned) => data(api.put(`/plants/${plantId}/kids/${kidId}`, { assigned })),
  seen: (plantId) => data(api.post(`/kid/plants/${plantId}/seen`)),
};

export const PICTURES = {
  sun: [Sun, "#FFB800"], moon: [Moon, "#5E5CE6"], star: [Star, "#FFCC00"], heart: [Heart, "#FF375F"],
  leaf: [Leaf, "#30D158"], flower: [Flower, "#FF6BB5"], dog: [Dog, "#A2845E"], cat: [Cat, "#FF9F0A"],
  fish: [Fish, "#0A84FF"], bird: [Bird, "#64D2FF"], drop: [Drop, "#32ADE6"], rainbow: [Rainbow, "#AF52DE"],
};

export const AVATARS = {
  bunny: [Rabbit, "#FF9EC4"], cat: [Cat, "#FF9F0A"], dog: [Dog, "#C6A27B"], bird: [Bird, "#64D2FF"],
  butterfly: [Butterfly, "#AF52DE"], fish: [Fish, "#0A84FF"], horse: [Horse, "#A2845E"], cow: [Cow, "#8E8E93"],
};

export const KID_JOBS = {
  watering: { label: "I watered it", done: "Watered!", Icon: Drop, color: "#0A84FF", tip: "Poke your finger into the soil first. If it feels dry, it's time to water. If it's wet, wait!" },
  misting: { label: "I misted the leaves", done: "Misted!", Icon: SprayBottle, color: "#64D2FF", tip: "A few gentle sprays is plenty. Leaves love a little drink of fog." },
  turning: { label: "I turned it to the light", done: "Turned!", Icon: Sun, color: "#FFB800", tip: "Plants lean toward the sun. A small turn helps them grow straight and strong." },
  dusting: { label: "I wiped the leaves", done: "Sparkly!", Icon: Sparkle, color: "#30D158", tip: "Use a soft damp cloth and be gentle. Clean leaves catch more sunlight." },
};

export const SIGNS = [
  ["droopy", "Droopy"], ["yellow-leaves", "Yellow leaves"], ["brown-spots", "Brown spots"], ["bugs", "Tiny bugs"],
  ["dry-crispy", "Dry and crispy"], ["mushy", "Mushy or soft"], ["other", "Something else"],
];

export const LESSONS = [
  { key: "soil-check", title: "Is my plant thirsty?", color: "#A2845E", Icon: HandPointing, steps: [
    [Hand, "Wash your hands, then gently poke one finger into the soil, up to your first knuckle."],
    [Drop, "Feels dry? Your plant is thirsty. Feels damp or cold? It still has water. Wait a day or two."],
    [CheckCircle, "Tap 'I watered it' in the app so everyone knows your plant had a drink."],
  ] },
  { key: "watering", title: "How much water?", color: "#0A84FF", Icon: Drop, steps: [
    [Drop, "Pour slowly around the plant, not on the leaves, until a little water comes out of the bottom."],
    [Ruler, "Small pot? A small cup. Big pot? A bigger cup. Too much water can make roots sad."],
    [Eye, "Empty the saucer after 10 minutes so the roots don't sit in a puddle."],
  ] },
  { key: "light", title: "Plants love light", color: "#FFB800", Icon: Lightbulb, steps: [
    [Sun, "Plants make their food from light. Most like bright light, but not hot sun all day."],
    [Eye, "Leaning plant? It's reaching for light. Give the pot a little turn every week."],
    [Moon, "Pale or stretched leaves can mean it needs a brighter spot. Tell a grown-up!"],
  ] },
  { key: "photo", title: "Take a great plant photo", color: "#AF52DE", Icon: Camera, steps: [
    [Sun, "Stand where there's lots of light, so your photo is bright and clear."],
    [DeviceMobile, "Hold the phone or tablet with two hands and keep it still. Tap the button once."],
    [Leaf, "Show the whole plant, then get close to anything that looks different. Photos help us see changes."],
  ] },
  { key: "sick-signs", title: "Spotting a sick plant", color: "#FF453A", Icon: WarningCircle, steps: [
    [Leaf, "Healthy leaves look firm and colorful. Look for yellow, brown, droopy or crispy leaves."],
    [Bug, "Look under the leaves for tiny bugs or sticky spots. Never squish them; just look!"],
    [ChatCircleDots, "Tap 'It looks sick' and tell your grown-up. You're the plant's first helper."],
  ] },
  { key: "using-the-app", title: "Using the app safely", color: "#30D158", Icon: DeviceMobile, steps: [
    [HandPointing, "Tap big buttons once and wait. The app will cheer when it's saved."],
    [Heart, "Only use the app with a grown-up nearby, and keep your secret pictures to yourself."],
    [CheckCircle, "Done helping? Tap your animal at the top and sign out."],
  ] },
];
